exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.issueBox {\n  background: #fff;\n  width: 100%; }\n  .issueBox .issueBoxTitle {\n    width: 100%;\n    height: 150px; }\n    .issueBox .issueBoxTitle .issueTitle {\n      width: 230px;\n      height: 100px;\n      background: url(" + require("./images/议题提交.png") + ") no-repeat center;\n      margin: 0 auto;\n      text-align: center;\n      line-height: 100px;\n      font-size: 24px;\n      font-weight: 900; }\n  .issueBox .issueForm .issue .ant-rate-star-full .anticon:before {\n    color: #2f72ff; }\n  .issueBox .issueForm .issue .ant-rate .issue {\n    width: 200px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/pages/issue/index.scss
// module id = 647
// module chunks = 0